import { computed, signal } from "alien-signals";

export const viewportHeight = signal(document.documentElement.clientHeight);

export const viewportWidth = signal(document.documentElement.clientWidth);

export const isZoomed = computed(() => {
  return viewportWidth() !== window.innerWidth;
});

export const orientation = signal(checkOrientation());

function checkOrientation() {
  if (window.matchMedia("(orientation: landscape)").matches) {
    return "landscape";
  } else if (window.matchMedia("(orientation: portrait)").matches) {
    return "portrait";
  }
}

function handleReflow() {
  viewportHeight(document.documentElement.clientHeight);
  viewportWidth(document.documentElement.clientWidth);
  orientation(checkOrientation());
}

const delay = 250;
let timeout;

export const settings = {
  delay,
};

window.addEventListener("resize", () => {
  clearTimeout(timeout);
  timeout = setTimeout(handleReflow, settings.delay);
});
